<template>
	<div>
		<el-row type="flex" justify="center" class="customFadeInDown delay-0-1s slow">
			<el-col :span="24">
				<el-row><el-image :src="banner"></el-image></el-row>
				<el-row type="flex" justify="start" style="position: relative;top: -34%;padding-left:9%;"><el-image :src="phone"></el-image></el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center">
			<el-col :span="24" style="margin-top:-5%;">
				<el-row><el-image :src="support_bg"></el-image></el-row>
				<el-row type="flex" justify="center" style="position: relative;top:-88%;">
					<ul class="support_ul">
						<li><el-image :src="support_train"></el-image></li>
						<li><el-image :src="support_sys"></el-image></li>
						<li><el-image :src="support_bus"></el-image></li>
					</ul>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center" style="display: none;">
			<el-col :span="24">
				<el-row><el-image :src="standard_bg"></el-image></el-row>
				<!--<el-row><el-image :src="map"></el-image></el-row>-->
			</el-col>
		</el-row>
		
	</div>
</template>
<script>
	import connect from '@/util/connect.js'
    export default {
        data() {
            return {
                banner:require("../../assets/join_new/banner.png"),
				phone:require("../../assets/join_new/phone.png"),
				support_bg:require("../../assets/join_new/support_bg.png"),
				support_train:require("../../assets/join_new/support_train.png"),
				support_sys:require("../../assets/join_new/support_sys.png"),
				support_bus:require("../../assets/join_new/support_bus.png"),
				standard_bg:require("../../assets/join_new/standard_bg.png"),
				map:require("../../assets/join_new/map.png"),
            }
        },
        mounted() {
			
        },
        computed: {
            
        },
        methods: {
			
        }
	}
</script>
<style>
	.el-image__inner--center{top:0;}
</style>
<style scoped>
	@import "../../assets/css/common.css";
	@import "../../assets/css/animation.css";
	ul.support_ul{margin:0;padding:0;height:0;}
	ul.support_ul li{list-style-type: none;float:left;}
	
</style>